exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".card-company[data-v-7daa9020]:hover{cursor:pointer;background-color:rgba(66,66,255,.87);color:#fff}", "", {"version":3,"sources":["/vercel/path0/src/components/Login/TableAccess.vue"],"names":[],"mappings":"AACA,qCACG,eAAgB,AAChB,qCAA0C,AAC1C,UAAa,CACf","file":"TableAccess.vue","sourcesContent":["\n.card-company[data-v-7daa9020]:hover {\n   cursor: pointer;\n   background-color: rgba(66, 66, 255, 0.87);\n   color: white;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7daa9020","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login/TableAccess.vue
// module id = 475
// module chunks = 6